var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "filter-container" },
    [
      _c(
        "label",
        { staticClass: "filter-label", attrs: { for: "search-filter-select" } },
        [_vm._v(_vm._s(_setup.TEXT.searchIn))]
      ),
      _c("v-select", {
        staticClass: "filter-select",
        attrs: {
          id: "search-filter-select",
          items: _setup.filterOptions,
          "item-text": "label",
          "item-value": "id",
          "return-object": "",
          outlined: "",
          dense: "",
          "hide-details": "",
          "menu-props": { bottom: true, offsetY: true, top: false },
        },
        on: {
          change: _setup.onSelectChange,
          focus: function ($event) {
            _setup.isMenuOpen = true
          },
          blur: function ($event) {
            _setup.isMenuOpen = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "select-content" }, [
                  _c("img", {
                    staticClass: "select-icon",
                    attrs: { src: item.icon },
                  }),
                  _c("span", { staticClass: "select-text" }, [
                    _vm._v(_vm._s(item.selectedText || item.label)),
                  ]),
                ]),
              ]
            },
          },
          {
            key: "append",
            fn: function () {
              return [
                _c("div", { staticClass: "chevron-container" }, [
                  _c("img", {
                    class: [
                      "chevron-icon",
                      { "chevron-rotated": _setup.isMenuOpen },
                    ],
                    attrs: { src: _setup.ICONS.chevronDown },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "item",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "menu-item-content" }, [
                  _c("img", {
                    staticClass: "menu-item-icon",
                    attrs: { src: item.icon },
                  }),
                  _c("div", { staticClass: "menu-item-text-wrapper" }, [
                    _c("span", { staticClass: "menu-item-label" }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                    item.description
                      ? _c("span", { staticClass: "menu-item-description" }, [
                          _vm._v(_vm._s(item.description)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _setup.selectedOption,
          callback: function ($$v) {
            _setup.selectedOption = $$v
          },
          expression: "selectedOption",
        },
      }),
      _setup.openedPrompt
        ? _c(_setup.PromptDialogComponent, {
            attrs: {
              title: _setup.promptTitle,
              isOpened: _setup.openedPrompt,
              context: _setup.promptContext,
              formSchema: _setup.currentFormSchema,
              formFieldValues: _setup.formData,
              width: 640,
            },
            on: { "execute-action": _setup.handleExecutePromptAction },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }